export default function useIsBrowser() {
  return typeof window !== 'undefined' && typeof document !== 'undefined' && typeof document.createElement === 'function'
}
